import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_Ztie32MsQxJf: {
	id: 'prd_Ztie32DEV22MsQxJf'
	ident: 'prd_Ztie32MsQxJf'
	sku: 'simple_premium_4w_9_99_4w_44_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: 1
			price_id: 'prc_rTPQq2DEV2ds3lbM4'
			amount: 44
			amount_usd: 9.99
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 9.99
			discount: 34.01
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: null
			price_id: 'prc_XsXUk2DEV2GM3DWlP'
			amount: 44
			amount_usd: 44
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_Ztie32MsQxJf, SubscriptionProduct>
const prd_Ztie32MsQxJf = { ident: 'prd_Ztie32MsQxJf' } as typeof _prd_Ztie32MsQxJf

export default prd_Ztie32MsQxJf
